import styled from 'styled-components';
import { SectionParent } from '../../../components/StyledComponents';

import React from 'react';
import tick from '../../../assets/v2/Pricing/tick.svg';
import cross from '../../../assets/v2/Pricing/cross.svg';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f4f6fb;
  padding-top: 6rem !important;
  padding-bottom: 8rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const TickImg = styled.img`
  height: 1rem;
  width: 1.3rem;
`;
const CrossImg = styled(TickImg)`
  width: 1rem;
`;

const HeroTitle = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.94;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  padding-bottom: 2rem;
  color: #4f5263;
  width: 50%;
  @media (max-width: 768px) {
    padding: 0rem;
    width: 100%;
    padding-bottom: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;

const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 60%;
  padding-top: 3rem;
  @media (max-width: 800px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const FirstRowHeader = styled.div`
  display: grid;
  grid-column: span 2;
  height: 5rem;
  background-color: #232a57;
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
  display: grid;
  align-items: center;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;
const SecondRowHeader = styled(FirstRowHeader)`
  background-color: #ffffff;
  grid-column: span 1;
  border-radius: 8px 8px 0 0;
  margin-left: -10px;
`;
const ThirdRowHeader = styled(SecondRowHeader)`
  background-color: #ffffff;
  grid-column: span 1;
  border-radius: 8px 8px 0 0;
  margin-left: 10px;
  @media (max-width: 1300px) {
    font-size: 14px;
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    font-size: 12px;
  }
`;

const RowContainer = styled.div`
  display: grid;
  grid-column: span 4;
  grid-template-columns: repeat(4, 1fr);
  height: fit-content;
  width: 100%;
  @media (max-width: 520px) {
    grid-column: span 5;
    grid-template-columns: repeat(5, 1fr);
  }
`;

const FirstRowColumn = styled.div`
  display: grid;
  grid-column: span 2;
  align-content: center;
  /* justify-content: center; */
  text-align: left;
  background-color: #232a57;
  padding: 1rem;
  padding-left: 2rem;
  font-size: 15px;
  height: fit-content;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  border-top: 0.2px solid #4f5475;
  color: #e9ecff;
  height: 100%;
  @media (max-width: 520px) {
    padding-left: 0.5rem;
    line-height: normal;
  }
`;

const SecondRowColumn = styled(FirstRowColumn)`
  display: grid;
  grid-column: span 1;
  background-color: #f4f5fc;
  color: #555761;
  margin-left: -10px;
  border-top: none;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19) !important;
  align-content: center;
  justify-content: center;
`;

const ThirdRowColumn = styled(SecondRowColumn)`
  margin-left: 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  color: #9095ab;
  @media (max-width: 520px) {
    font-size: 12px;
    grid-column: span 2;
  }
`;
export default class PricingSectionFour extends React.Component<any, any> {
  render() {
    return (
      <Section>
        <HeroTitle>{this.props?.messages?.HomePageEsperVsMDMTitle}</HeroTitle>
        <SubHeading>
          {this.props?.messages?.HomePageEsperVsMDMDesc1}
          <br />
          <br />
          {this.props?.messages?.HomePageEsperVsMDMDesc2}
        </SubHeading>
        <TableContainer>
          <FirstRowHeader>
            {this.props?.messages?.HomePageEsperVsMDMFeatures}
          </FirstRowHeader>
          <SecondRowHeader style={{ color: '#9568d0' }}>ESPER</SecondRowHeader>
          <ThirdRowHeader style={{ color: '#232a57' }}>
            TRADITIONAL <br />
            MDM
          </ThirdRowHeader>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesDeviceManagement}
            </FirstRowColumn>
            <SecondRowColumn>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <TickImg alt="Esper Tick" src={tick} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCompatible}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              {
                this.props.messages
                  ?.HomePageEsperVsMDMFeaturesCompatibleTraditionalMDM
              }
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesKioskMode}
            </FirstRowColumn>
            <SecondRowColumn>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesPipelines}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCustomDevice}
            </FirstRowColumn>
            <SecondRowColumn>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesVirtual}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesRemoteDebug}
            </FirstRowColumn>
            <SecondRowColumn>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesOSEnhancement}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesHardwareVendors}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCustomAndroid}
            </FirstRowColumn>
            <SecondRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <TickImg alt="Esper Tick" src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <CrossImg alt="Esper Cross" src={cross} />
            </ThirdRowColumn>
          </RowContainer>
        </TableContainer>
      </Section>
    );
  }
}
